import {API} from "../constants/constants";

export const completeReportResult = async (data: any) => {
    let url = window.location.origin + API.BASE_URL + API.COMPLETE_REPORT_RESULT

    return await fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response) => response.json()).then((response) => {
        return response.data as any[]
    }).catch((error) => {
        return {
            errorMessage: error
        }
    });
}

export const createRequest = async (data: any) => {
    let url = window.location.origin + API.BASE_URL + API.CREATE_UPDATE

    return await fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response) => response.json()).then((response) => {
        return response as any
    }).catch((error) => {
        return {
            errorMessage: error
        }
    });
}

export const uploadFiles = async (files: FileList | File[], reportingNumberId: string) => {
    let url = window.location.origin + API.BASE_URL + API.UPLOAD + reportingNumberId
    const formData = new FormData();

    Array.from(files).forEach(file => {
        formData.append('files[]', file);
    });

    return await fetch(url, {
        method: "POST",
        body: formData,
    }).then((response) => response.json()).then((response) => {
        return response as any
    }).catch((error) => {
        return {
            errorMessage: error
        }
    });
}